export const backend_url = "https://ceylon-ambessodor-server.azurewebsites.net";
